<app-grid-wrapper
  #grid
  [gridSize]="GridSize.small"
  persistenceKey="readyToPayList"
  [autoHeight]="false"
>
  <div class="row">
    <div class="col-xs-2">
      <button
        class="btn btn-primary"
        [disabled]="model.selected.length === 0"
        (click)="generatePayment.emit(model.selected)"
      >
        Generate Provider Remittance
      </button>
    </div>
    <div class="col-xs-2">
      <button
        class="btn btn-primary"
        [disabled]="model.selected.length === 0"
        (click)="returnToRemitReceived()"
      >
        Return to Remit Received
      </button>
    </div>
    <div class="col-xs-8 text-center">
      Total Payment:
      <span
        class="payment"
        [ngClass]="{ negative: model.payAmount < 0, positive: model.payAmount > 0 }"
        >{{ model.payAmount | currency }}</span
      >
    </div>
  </div>
</app-grid-wrapper>
